<template>
  <div
    id="app"
    class="app"
  >
    <p class="app__print-title">
      Miniatur Wunderland Hamburg
    </p>

    <c-page-header />
    <router-view />
    <c-page-footer />

    <c-event-modal
      v-if="event.show"
      :event-data="event.data"
      @close="hideEvent"
    />

    <c-modal
      v-if="message.show"
      :title="message.title"
      size="medium"
      no-close
      center-content
    >
      <p v-html="message.message" />

      <template #footer>
        <c-button-group align="center">
          <c-action
            v-for="button in message.buttons"
            :key="button.label"
            :color="button.color"
            @click="callBack(button.callback)"
          >
            {{ button.label }}
          </c-action>
          <c-action
            v-if="message.showOk"
            color="primary"
            @click="closeMessage"
          >
            Ok
          </c-action>
        </c-button-group>
      </template>
    </c-modal>
  </div>
</template>

<script>
import CAction from './components/action.vue'
import CButtonGroup from './components/buttonGroup.vue'
import CEventModal from './components/eventModal.vue'
import CModal from './components/modal.vue'
import CPageFooter from './components/pageFooter.vue'
import CPageHeader from './components/pageHeader.vue'

import dateHelper from './functions/dateHelper.js'
import errors from './functions/errors.js'
import eventBus from './eventBus.js'

export default {
  name: 'App',

  components: {
    CAction,
    CButtonGroup,
    CEventModal,
    CModal,
    CPageFooter,
    CPageHeader
  },

  data () {
    return {
      message: {
        show: false,
        title: '',
        message: '',
        buttons: [],
        showOk: true
      },
      event: {
        show: false,
        data: {}
      }
    }
  },

  async created () {
    try {
      await Promise.all([
        this.$store.dispatch('getLabels'),
        this.$store.dispatch('getConfig'),
        this.$store.dispatch('getAllArticles'),
        this.$store.dispatch('getGaps', { date: dateHelper.formatDate() }),
        this.$store.dispatch('getGaps', { date: dateHelper.formatDate(dateHelper.dayAfter()) })
      ])

      eventBus.emit('articlesLoaded')
    } catch (error) {
      eventBus.emit('handleError', error.response.data.error)
    } finally {
      this.$store.commit('setLoading', false)
    }

    eventBus.on('handleError', (message, extraButtons) => {
      if (typeof message === 'undefined') {
        message = errors(this.$i18n.locale)[1000]
      }

      this.showError(message, extraButtons)
    })

    eventBus.on('showMessage', payload => {
      this.showMessage(payload)
    })

    eventBus.on('closeMessage', () => {
      this.closeMessage()
    })

    eventBus.on('showEvent', eventData => {
      if (eventData) {
        this.event.data = eventData
        this.showEvent()
      }
    })

    eventBus.on('closeEvent', () => {
      this.hideEvent()
    })
  },

  beforeDestroy () {
    eventBus.off('handleError')
    eventBus.off('showEvent')
    eventBus.off('closeEvent')
    eventBus.off('showMessage')
    eventBus.off('closeMessage')
  },

  methods: {
    goto (routerLink) {
      this.hideError()
      this.$router.push({ name: routerLink })
    },
    showError (message, buttons) {
      const payload = {
        title: this.$t('errorTitle'),
        message: message,
        showOk: true,
        buttons: []
      }
      for (const bIndex in buttons) {
        payload.buttons.push({ label: this.$t(bIndex), callback: this.goto(buttons.bIndex) })
      }

      this.showMessage(payload)
    },
    hideError () {
      this.closeMessage()
    },
    showEvent () {
      this.event.show = true
    },
    hideEvent () {
      this.event.show = false
      this.event.data = {}
    },
    showMessage (payload) {
      this.message.title = payload.title
      this.message.message = payload.message
      this.message.buttons = payload.buttons
      this.message.showOk = payload.showOk
      this.message.show = true
    },
    closeMessage () {
      this.message.title = ''
      this.message.message = ''
      this.message.buttons = []
      this.message.showOk = true
      this.message.show = false
    },
    callBack (callback) {
      if (callback) {
        callback()
      }

      this.closeMessage()
    }
  }
}
</script>

<i18n locale="en">
{
  "errorTitle": "Oops!",
  "reservation": "Go to reservation"
}
</i18n>

<i18n locale="de">
{
  "errorTitle": "Ups!",
  "reservation": "Zur Reservierung"
}
</i18n>

<style lang="scss">
.app__print-title {
  display: none;

  @media print {
    display: block;
    font-size: 1.75em;
  }
}
</style>
